import firebase from '@/firebase/init'

export default firebase.firestore()